export const capitalize = (value: string): string =>
	value.charAt(0).toLocaleUpperCase() + value.slice(1);

export const snakeCaseToCamelCase = (value: string): string =>
	value.length
		? value
				.split("_")
				.map((word: string, index: number): string => {
					word = word.toLocaleLowerCase();
					return index ? capitalize(word) : word;
				})
				.join("")
		: "";

export const camelCaseToSnakeCase = (value: string): string =>
	value.length
		? value
				.split(/(?=[A-Z])/)
				.map((word: string): string => word.toLocaleLowerCase())
				.join("_")
		: "";

// NOTE helper: in CSS, it's better to use hyphens (-) instead of underscores (_) in class names
export const snakeCaseToKebabCase = (value: string): string =>
	value.length
		? value
				.split("_")
				.map((word: string): string => word.toLocaleLowerCase())
				.join("-")
		: "";

export const spaceToKebabCase = (value: string): string =>
	value.length
		? value
				.split(" ")
				.map((word: string): string => word.toLocaleLowerCase())
				.join("-")
		: "";
